import { Component, Inject, OnInit } from '@angular/core';

@Component({
    selector: 'rwidget-register-aside',
    templateUrl: './register-aside.component.html',
    styleUrls: ['./register-aside.component.scss']
})
export class RegisterAsideComponent implements OnInit {
    constructor(
        @Inject('ENV') public env: any,
    ) {}


    ngOnInit() {
    }

}
